export enum ActionTypes {
  SET_FILTER = 'SET_FILTER',
  CLEAR_FILTERS = 'CLEAR_FILTERS',
  SET_HELPDESK_FILTER = 'SET_HELPDESK_FILTER'
}
